import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { ICalculatePriceOverride } from '../../../common/interfaces/dtos/ICalculatePriceOverride';

export const calculatePriceOverride = async (
  inputData: ICalculatePriceOverride,
): Promise<number> => {
  const finalData = {
    value: inputData.priceModifierValue,
    itemId: inputData.ItemId,
    quantity: inputData.Quantity,
    action: inputData.priceModifierAction,
  };

  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${inputData.TransactionID}/items/${inputData.SequenceNumber}/price-override`,
    method: 'GET',
    params: finalData,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoggingInfo: true,
  };

  const response = await emeraldRequest<number>(emeraldRequestParams);
  return response;
};
